(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const syncPlayback = (video) => {
    if (reducedMotion.matches) {
      video.pause();
      return;
    }

    const playPromise = video.play();
    if (playPromise !== undefined) playPromise.catch(() => {});
  };

  const initializeVideoBanners = (root = document) => {
    root.querySelectorAll('[data-video-banner]').forEach((banner) => {
      if (banner.dataset.videoBannerReady === 'true') return;

      const video = banner.querySelector('video');
      if (!video) return;

      banner.dataset.videoBannerReady = 'true';
      syncPlayback(video);
      reducedMotion.addEventListener('change', () => syncPlayback(video));
    });
  };

  initializeVideoBanners();
  document.addEventListener('shopify:section:load', (event) => initializeVideoBanners(event.target));
})();
